import React from 'react';

import AuthTemplate from '@src/templates/Auth';
import SignInForm from '@src/components/forms/SignInForm';
import SignInIllustrationSrc from '@public/img/illustrations/sign-in.svg';

const SignInTemplate = () => (
  <AuthTemplate
    illustrationSrc={SignInIllustrationSrc}
    illustrationAlt="A guy looking at a big chart right in front of him.">
    <SignInForm />
  </AuthTemplate>
);

export default SignInTemplate;
